import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// Components

import Form from '@lib/wrappers/Form';
import UniversalInput from '@lib/wrappers/UniversalInput';

// ActionCreators

import { changeData } from '@actions/ssap/ssapActionCreators';

// Hooks

import { useInternationalizedOptions } from '@hooks/useInternationalizedOptions';

// Utils

import { currencyTools } from '@utils/tools/currencyTools';
import { filterTools } from '@utils/tools/filterTools';
import { internationalizeList } from '@utils/miscellaneous/internationalizeList';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';
import { FREQUENCY_LIST, INCOME_SOURCES_LIST } from '@constants/ssap/hhmTypes/dropdownOptions';



const Page3_33_E1 = props => {

    const {
        data,
        formName,
    } = props;

    const {
        hhmIndex : member,
        currentHhm
    } = props;

    const {
        incomes
    } = currentHhm;

    const onFieldChange = (newData, index) => {
        const newState = { ...data };
        newState
            .taxHousehold
            .householdMember[member]
            .incomes[index] = newData;
        props.actions.changeData(newState);
    };

    const getLis = () => {

        const ids = [
            'ssap.income_information.tribal_income.item.per_capita',
            'ssap.income_information.tribal_income.item.natural_sources',
            'ssap.income_information.tribal_income.item.selling'
        ];

        return internationalizeList(ids, 'li');
    };

    const sources = useInternationalizedOptions({ ...INCOME_SOURCES_LIST });
    const frequencies = useInternationalizedOptions({ ...FREQUENCY_LIST });

    const getThs = () => {

        const ids = [
            'common.income_source',
            'common.amount',
            'common.how_often',
            'common.tribal_income'
        ];

        return internationalizeList(ids, 'th', { scope: 'col' });
    };
    const getTribalEligibleIncomeSources = () => {
        return incomes.map(
            (source, idx) => {

                const {
                    amount,
                    tribalAmount
                } = source;

                const key = `${ source.type }_${ idx }`;

                // Excluding income source from render could be done easier
                // but keeping filters usage makes tribal logic be unified across components
                if(
                    filterTools.combinedFilterByType(
                        filterTools.removeDummyType,
                        filterTools.removeSocialSecurityType,
                        filterTools.removeUnemploymentType
                    )(source) === false
                ) {
                    return <tr key = { key } />;
                }

                return (
                    <tr key = { key }>
                        <td>
                            { sources[source.type] }
                        </td>
                        <td>
                            { currencyTools.getMoneyFormat(source.amount, true) }
                        </td>
                        <td>
                            { frequencies[source.frequency] }
                        </td>
                        <td>
                            <UniversalInput
                                label = { {
                                    text: 'ssap.input.label.amount',
                                    labelClasses: [ 'usa-sr-only' ]
                                } }
                                inputData = { {
                                    isInputRequired: false,
                                    type: INPUT_TYPES.MONEY_INPUT,
                                    name: 'tribalAmount',
                                    value: tribalAmount,
                                    valuesToMatch: amount >= 0 ? [ 0, amount ] : [],
                                    helperClasses: [ 'margin-0', 'padding-0' ],
                                    isOnlyPositiveAvailable: true,
                                    placeholder: 'ssap.input.placeholder.amount',
                                    validationType: VALIDATION_TYPES.MONEY_NOT_EXCEED,
                                    currentData: { ...source },
                                    fields: [ ]
                                } }
                                errorClasses = { [ 'margin-l-0 margin-b-10' ] }

                                inputActions = { {
                                    onFieldChange
                                } }
                                indexInArray = { idx }
                            />
                        </td>
                    </tr>
                );
            }
        );
    };

    return (
        <Fragment>
            <div id = 'iiTribalIncome' >
                <div className = 'subsection' >
                    <FormattedMessage
                        id = 'ssap.income_information.tribal_income.is_income_from_ai_an'
                        tagName = 'h4'
                    />
                    <ul className = 'usa-list gi-list--ul' >
                        { getLis() }
                    </ul>
                    <Form { ...{ formName } }>
                        <div className = 'grid-row gi-table__responsive' >
                            <table className = 'usa-table usa-table--borderless gi-table gi-table__borderless' >
                                <thead>
                                    <tr>
                                        { getThs() }
                                    </tr>
                                </thead>
                                <tbody>
                                    { getTribalEligibleIncomeSources() }
                                </tbody>
                            </table>
                        </div>
                    </Form>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Page3_33_E1);
